import './src/css/fonts.css';
import './src/css/index.css';
import './src/css/grid.css';
import './src/css/web-components.css';
import './src/css/phone-number.css';
import './src/css/header-footer-custom.css';
import './src/css/lead-form.css';
import './src/css/company-value-prop.css';
import './src/css/need-health-insurance.css';
import './src/css/testimonials.css';
import './src/css/comparison-carousel.css';
import './src/css/states.css';

import wrapWithPageData from './wrap-with-pagedata';
import wrapWithProvider from './wrap-with-provider';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = wrapWithPageData;
